<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader
        :loading="!flagNav"
        max-height="64" 
        type="table-heading"
        >
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">Create Model</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
      <v-card class="card2" style="margin-top: 1rem">
        <v-col>
         <ModelManagement
          :editAction="isEditAction"
          :LLmsModel="GPTModel"
          :modelID="$route.query.id"
          :GetDDModel="isParam"
          :view-only="isViewOnly"
          :show-compare-button="Boolean($route.query.id)"
          :compare-button-disabled="!GPTModel.modelIDGroup || loadingCompareVersions || compareLoading"
          :compare-button-loading="loadingCompareVersions || compareLoading"
          @open-compare="openCompareVersionSelector"
          @open-compare-file="compareWithFile"
          />
        </v-col>
      </v-card>
    </v-container>
    <v-dialog v-model="compareVersionDialog" max-width="900px" scrollable>
      <v-card>
        <v-card-title>
          <div class="compare-dialog-title">Compare With Version</div>
          <div class="compare-dialog-subtitle">Select one version to compare against the current draft.</div>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="compareVersionHeaders"
            :items="compareVersions"
            :loading="loadingCompareVersions"
            item-key="modelId"
            density="comfortable"
          >
            <template v-slot:item.versioning="{ item }">
              <div class="d-flex align-center">
                <v-chip size="small" color="primary" variant="tonal">v{{ item.versioning }}</v-chip>
                <v-chip v-if="item.isPublish" size="x-small" color="success" class="ml-2">Current</v-chip>
              </div>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                color="primary"
                variant="outlined"
                size="small"
                :loading="compareLoading"
                @click="compareWithVersion(item)"
              >
                Compare
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" variant="outlined" @click="compareVersionDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="compareDialog" max-width="1200px" scrollable>
      <v-card class="compare-dialog-card">
        <v-card-title>
          <div class="compare-dialog-title">Model Draft Compare</div>
          <div class="compare-dialog-subtitle">Review changes between the current form state and the selected historical version.</div>
        </v-card-title>
        <v-card-text>
          <GPTModelCompare
            v-if="comparePayload.leftModel && comparePayload.rightModel"
            :left-model="comparePayload.leftModel"
            :right-model="comparePayload.rightModel"
            :left-title="comparePayload.leftTitle"
            :right-title="comparePayload.rightTitle"
            :allow-apply-text="true"
            :excluded-keys="compareExcludedKeys"
            default-view="summary"
            @apply-field="applyComparedField"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" variant="outlined" @click="closeCompareDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" persistent width="300">
      <v-card color="#1976D2" theme="dark">
        <v-card-text class="white--text">
          Loading Please Wait...
          <v-progress-linear indeterminate color="#FAA91B" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import checkPermissionTwo from '@/api/function.js';
import LogTrace from '@/api/function.js';
import GPTModelCompare from '@/components/GPTModelCompare.vue';
import ModelManagement from '@/components/ModelManagement.vue';
import { kccPickerSource } from '@/services/kccPickerSource';
export default {
  name: 'GPTModeDetail',
  inject: [
    "flagNav",
    "FontColorTitle",
    "SubNavbarBackGround",
  ],
  components: { GPTModelCompare, ModelManagement },
  mixins: [checkPermissionTwo, LogTrace],
  data: () => ({
    props: ['id'],
    id: null,
    valid: true,
    checkbox1: false,
    isEditAction: false,
    dialog: false,
    compareVersionDialog: false,
    compareDialog: false,
    compareLoading: false,
    loadingCompareVersions: false,
    compareVersions: [],
    compareVersionHeaders: [
      { title: 'Version', key: 'versioning', align: 'center', sortable: false, width: '140px' },
      { title: 'Modified', key: 'updateDate', align: 'center', sortable: false },
      { title: 'Modified By', key: 'updateBy', align: 'center', sortable: false },
      { title: 'Actions', key: 'actions', align: 'center', sortable: false, width: '120px' },
    ],
    comparePayload: {
      leftModel: null,
      rightModel: null,
      leftTitle: '',
      rightTitle: '',
    },
    compareExcludedKeys: ['versioning', 'isPublish'],
    tempID: 0,
    MenuID1: null,
    MenuID2: null,
    MenuID3: null,
    menuID: null,
    subMenuID: null,
    today: null,
    maxLengthChar: null,
    loading: true,
    switch1: true,
    panel: [5],
    rules: {
      required: (value) => !!value || 'Required.',
    },
    GPTModel_isPublish: false,
    GPTModel: {
      typeLLM:0,
      modelId: null,
      modelName: null,
      provider: null,
      model: null,
      APIVersion: null,
      extension: null,
      description: null,
      promptTemplate: '',
      gender: null,
      vectordbName: [],
      groupReplaceID: null,
      productGroupID: [],
      topVDB: null,
      productTopVDB: null,
      productCosine: null,
      internet: null,
      feedback: null,
      historyCount: null,
      historyMinute: null,
      temperature: null,
      topP: null,
      frequencyPenalty: null,
      presencePenalty: null,
      stop: null,
      maxTokens: null,
      isStream: false,
      isBypass: false,
      isFeedback: false,
      isAllowImage: false,
      isShowNameUserMonitor: false,
      versioning: null,
      isPublish: true,
      modelIDGroup: null,
      modelDisplay: null,
      Len_ShortMemory: null,
      IsLongTerm_Memory: false,
      IsChainMassage: false,
      LenChainMassage: null,
      TimeSecondChainMassage: null,
      Cosine: null,
      DataIntegrationID : null,
      SqlModelID : null,
      promptSqlNoData : null,
      IntentGroupID : null,
      maximumChatInput : 200000,
      forbiddenWord:[""],
      jsonRequest:null,
      enableTime: null,
      timeZone: null,
      endPointURL: null,
      apI_Key: null,
      isAllowLLMChange: false,
      flowGroupID: null,
    },
    DDVector: [],
    DDGroupReplace: [],
    DDProvider: [
      'Azure',
      'Google'
    ],
    listDataIntegration: [],
    listSqlExtract : [],
    DDMinute: [
      {
        name: '0',
        value: 0,
      },
      {
        name: '2',
        value: -2,
      },
      {
        name: '10',
        value: -10,
      },
      {
        name: '30',
        value: -30,
      },
      {
        name: '60',
        value: -60,
      },
      {
        name: '720',
        value: -720,
      },
      {
        name: '1440',
        value: -1440,
      },
    ],
    DDModel: [
      {
        provider: 'Azure',
        model: 'gpt-35-turbo-chat',
        maxPrompt: 4000,
      },
      {
        provider: 'Azure',
        model: 'gpt-35-turbo-16k',
        maxPrompt: 8000,
      },
      {
        provider: 'Azure',
        model: 'gpt-4',
        maxPrompt: 6000,
      },
      {
        provider: 'Azure Postgresql',
        model: 'gpt-35-postgresql',
        maxPrompt: 4000,
      },
      {
        provider: 'Azure Postgresql',
        model: 'gpt-35-16k-postgresql',
        maxPrompt: 8000,
      },
      {
        provider: 'Azure Postgresql',
        model: 'gpt-4-postgresql',
        maxPrompt: 6000,
      },
      {
        provider: 'Azure Internet',
        model: 'gpt-35-Internet',
        maxPrompt: 4000,
      },
      {
        provider: 'Azure Internet',
        model: 'gpt-35-16k-Internet',
        maxPrompt: 8000,
      },
      {
        provider: 'Azure Internet',
        model: 'gpt-4-Internet',
        maxPrompt: 6000,
      },
      {
        provider: 'Azure News',
        model: 'gpt-35-turbo-chat',
        maxPrompt: 4000,
      },
      {
        provider: 'Azure News',
        model: 'gpt-35-turbo-16k',
        maxPrompt: 8000,
      },
      {
        provider: 'Azure News',
        model: 'gpt-4',
        maxPrompt: 6000,
      },
    ],
    DDModelShow: [],
    DDGender: [
      {
        id: 'm',
        name: 'Male',
      },
      {
        id: 'f',
        name: 'Female',
      },
    ],
    listDDModel: [],
    listDDIntentGroup: [],
    listDDProvider: [],
    showMenu: false,
    x: 0,
    y: 0,
    DDPromptTemplate: [],
    DDGroupPromptTemplate: [],
    PositionPromptTemplate: 0,
    showPromptTem: false,
    dialogShowAll: false,
    groupPromptTemplate: null,
    isParam: "",
  }),
  watch: {
    '$route.params.id': function (newParam) {
      // อัพเดตค่าพารามิเตอร์ด้วยตัวเอง
      this.id = newParam;
    },
    'GPTModel.provider': function (val) {
      if (val == null) {
        this.GPTModel.vectordbName = [];
        this.GPTModel.topVDB = null;
      }
    },
    // 'GPTModel.isStream' : {
    //   handler:function(){
    //     let self = this;
    //     self.GPTModel.typingSpeed = 40;
    //     // self.GPTModel.typingSpeed = val? (self.GPTModel.typingSpeed == null ? 40 : parseInt(self.GPTModel.typingSpeed)) : null;
    //   },
    //   immediate: true
    // },
    // 'GPTModel.vectordbName' : {
    //   handler:function(val){
    //     let self = this;
    //     if(val.length == 0){
    //       self.GPTModel.IsChainMassage = false;
    //     }
    //   },
    //   immediate: true
    // },
  },
  computed: {
    filteredPromptTemplates() {
      if (this.groupPromptTemplate === null) {
        return [];
      }
      return this.DDPromptTemplate.filter(
        item => item.groupPromptTemplateID === this.groupPromptTemplate
      );
    },
    isViewOnly() {
      // Inherit the parent page (GPTModelManagement) mode for the detail route.
      return this.$pagePermission && this.$pagePermission.isViewOnly('GPTModelDetail');
    },
  },
  methods: {
    ShowPromptTemplate (e) {
      e.preventDefault()
      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    async SetSelectPromptTemplate(val){
      let self = this;
      var strArray = self.GPTModel.promptTemplate.split("");
      strArray.splice(self.PositionPromptTemplate, 0, val.prompt);
      self.GPTModel.promptTemplate = strArray.join("");
    },
    validate() {
      this.$refs.form.validate();
    },
    async Get(id) {
      let self = this;
      self.dialog = true;
      self.loading = true;
      await self.$call.GetGPTModelById(
        id,
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            await self.Edit(dataResponse.data);
            await self.changeProvider(self.GPTModel.provider);
            await self.changeModel(self.GPTModel.model);
          } 
          self.dialog = false;    
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    async GetAllDDModelManagement() {
      let self = this;
      self.dialog = true;
      // App Knowledge Center (G10 · AC-9): ถามโหมดขนานกับ $call · โหมด Center ⇒ DDVector = เอกสารของ Center เท่านั้น
      // (picker จริงของหน้านี้อยู่ใน components/ModelManagement.vue ซึ่งโหลดรายการเอง)
      const kccVectorListPromise = kccPickerSource.vectorList();
      await self.$call.GetAllDDModelManagement(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDVector = dataResponse.data.vectorDBName;
            self.listDataIntegration = dataResponse.data.dataIntegration;
            self.DDGroupReplace = dataResponse.data.groupReplace;
            self.DDPromptTemplate = dataResponse.data.promptTemplate.listData;
            self.listDDProvider = dataResponse.data.provider;
            self.listDDModel = dataResponse.data.modelData;
            self.listDDIntentGroup = dataResponse.data.intentGroup;
            self.DDGroupPromptTemplate = dataResponse.data.groupPromptTemplate;
            if (self.$route.query.id){
               self.listSqlExtract = dataResponse.data.modelPublih.filter(e=>e.id != self.$route.query.id);
            }else{
              self.listSqlExtract = dataResponse.data.modelPublih;
            }
          } else {
            self.DDVector = [];
            self.listDataIntegration = [];
            self.listSqlExtract = [];
            self.DDGroupReplace = [];
            self.DDPromptTemplate = [];
            self.listDDProvider = [];
            self.listDDModel = [];
          }
          const kccList = await kccVectorListPromise; // ไม่ throw · null = โหมดปิด ⇒ ไม่แตะ
          if (kccList !== null) self.DDVector = kccList;
          self.dialog = false;
          if (self.$route.query.id) 
          {
            await self.Get(self.$route.query.id);
          } 
        },
        (errorResource) => {
          // self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    //   let self = this;
    //   self.dialog = true;
    //   await self.$call.GetAllDDModelManagement(
    //     async (dataResponse) => {
    //       if (dataResponse.status == 0) {
    //         self.DDVector = dataResponse.data.vectorDBName;
    //         self.listDataIntegration = dataResponse.data.dataIntegration;
    //         self.DDGroupReplace = dataResponse.data.groupReplace;
    //         self.DDPromptTemplate = dataResponse.data.promptTemplate.listData;
    //         self.listDDProvider = dataResponse.data.provider;
    //         self.listDDModel = dataResponse.data.modelData;
    //         self.listDDIntentGroup = dataResponse.data.intentGroup;
    //         self.DDGroupPromptTemplate = dataResponse.data.groupPromptTemplate;
    //         if (self.$route.query.id){
    //            self.listSqlExtract = dataResponse.data.modelPublih.filter(e=>e.id != self.$route.query.id);
    //         }else{
    //           self.listSqlExtract = dataResponse.data.modelPublih;
    //         }
    //       } else {
    //         self.DDVector = [];
    //         self.listDataIntegration = [];
    //         self.listSqlExtract = [];
    //         self.DDGroupReplace = [];
    //         self.DDPromptTemplate = [];
    //         self.listDDProvider = [];
    //         self.listDDModel = [];
    //       }
    //       self.dialog = false;
    //       if (self.$route.query.id) 
    //       {
    //         await self.Get(self.$route.query.id);
    //       } 
    //     },
    //     (errorResource) => {
    //       console.error(errorResource);
    //     }
    //   );
    // },
    // Save(actions) {
    //   let self = this;
    //   self.panel = [2, 4];
    //   setTimeout(() => {
    //     self.validate();
    //   }, 100);
      
    //   if(self.GPTModel.modelName == null || self.GPTModel.modelName == ''){
    //     self.$swal.fire({
    //       icon: 'warning',
    //       title: self.$t('warning'),
    //       text: self.$t('warningModelName'),
    //       showConfirmButton: false,
    //       timer: 3000,
    //     });
    //     return;
    //   }
    //   else if(!self.GPTModel.provider){
    //     self.$swal.fire({
    //       icon: 'warning',
    //       title: self.$t('warning'),
    //       text: self.$t('warningProvider'),
    //       showConfirmButton: false,
    //       timer: 3000,
    //     });
    //     return;
    //   }
    //   else if(!self.GPTModel.model ){
    //     self.$swal.fire({
    //       icon: 'warning',
    //       title: self.$t('warning'),
    //       text: self.$t('warningModel'),
    //       showConfirmButton: false,
    //       timer: 3000,
    //     });
    //     return;
    //   }
    //   else if(self.GPTModel.isPublish == null){
    //     self.$swal.fire({
    //       icon: 'warning',
    //       title: self.$t('warning'),
    //       text: self.$t('warningPublish'),
    //       showConfirmButton: false,
    //       timer: 3000,
    //     });
    //     return;
    //   }
    //   else if(self.GPTModel.temperature == null ||
    //     self.GPTModel.temperature < 0 ||
    //     self.GPTModel.temperature > 1 ||
    //     self.GPTModel.temperature === ''){
    //     self.$swal.fire({
    //       icon: 'warning',
    //       title: self.$t('warning'),
    //       text: self.$t('warningTemperature'),
    //       showConfirmButton: false,
    //       timer: 3000,
    //     });
    //     return;
    //   }
    //   else if(self.GPTModel.topP == null ||
    //     self.GPTModel.topP < 0 ||
    //     self.GPTModel.topP > 1 ||
    //     self.GPTModel.topP === ''){
    //     self.$swal.fire({
    //       icon: 'warning',
    //       title: self.$t('warning'),
    //       text: self.$t('warningTopP'),
    //       showConfirmButton: false,
    //       timer: 3000,
    //     });
    //     return;
    //   }
    //   else if(self.GPTModel.maximumChatInput == null ||
    //     self.GPTModel.maximumChatInput < 0 ||
    //     self.GPTModel.maximumChatInput === ''){
    //     self.$swal.fire({
    //       icon: 'warning',
    //       title: self.$t('warning'),
    //       text: self.$t('warningmaximumChatInput'),
    //       showConfirmButton: false,
    //       timer: 3000,
    //     });
    //     return;
    //   }
    //   else if((self.GPTModel.topVDB == null && self.GPTModel.vectordbName.length > 0 )){
    //     self.$swal.fire({
    //       icon: 'warning',
    //       title: self.$t('warning'),
    //       text: self.$t('warningTopVDB'),
    //       showConfirmButton: false,
    //       timer: 3000,
    //     });
    //     return;
    //   }
    //   else if ((self.GPTModel.APIVersion == '' || self.GPTModel.APIVersion == null) && self.GPTModel.provider != 'Google'){
    //     self.$swal.fire({
    //       icon: 'warning',
    //       title: self.$t('warning'),
    //       text: self.$t('warningAPIVersion'),
    //       showConfirmButton: false,
    //       timer: 3000,
    //     });
    //     return;
    //   }
    //   if (typeof self.validatePrompt(self.GPTModel.promptTemplate) == 'string') {
    //     self.$swal.fire({
    //       icon: 'warning',
    //       title: self.$t('warning'),
    //       text: 'Please Enter Correct Format!',
    //       showConfirmButton: false,
    //       timer: 1800,
    //     });
    //     return;
    //   }
    //   self.dialog = true;
    //   try {
    //     self.GPTModel.frequencyPenalty = self.GPTModel.frequencyPenalty != "" ? self.GPTModel.frequencyPenalty : null;
    //     self.GPTModel.presencePenalty = self.GPTModel.presencePenalty != "" ? self.GPTModel.presencePenalty : null;
    //     self.GPTModel.topVDB = self.GPTModel.topVDB != "" ? self.GPTModel.topVDB : null;
    //     self.GPTModel.IsLongTerm_Memory = self.GPTModel.provider == 'Google' ? false : (self.GPTModel.IsLongTerm_Memory ?? false);
    //     self.GPTModel.typingSpeed = parseInt(self.GPTModel.typingSpeed)
    //     self.GPTModel.maximumChatInput = parseInt(self.GPTModel.maximumChatInput)
    //     if (self.GPTModel.modelIDGroup == null) {
    //       self.$call.AddGPTModel(
    //         self.GPTModel,
    //         (dataResponse) => {
    //           if (dataResponse.status == 0) {
    //             self.$swal.fire({
    //               icon: 'success',
    //               title: dataResponse.message,
    //               showConfirmButton: false,
    //               timer: 1500,
    //             });
    //             if (actions == 's&c') self.$router.push('/GPTModelManagement');
    //             else
    //               self.Get(dataResponse.data);
    //           }
    //           if (dataResponse.status == 1 && dataResponse.data.is_exist) {
    //             self.$swal.fire({
    //               icon: 'error',
    //               title: 'Model ID is exist',
    //               showConfirmButton: false,
    //               timer: 1800,
    //             });
    //           }
    //           self.dialog = false;
    //         },
    //         (errorResource) => {
    //           self.dialog = false;
    //           self.Adddialog = false;
    //           console.error(errorResource);
    //         }
    //       );
    //     } else if (self.GPTModel.isPublish && self.GPTModel_isPublish) {
    //       self.$call.AddGPTModel(
    //         self.GPTModel,
    //         (dataResponse) => {
    //           if (dataResponse.status == 0) {
    //             self.$swal.fire({
    //               icon: 'success',
    //               title: dataResponse.message,
    //               showConfirmButton: false,
    //               timer: 1500,
    //             });
    //             if (actions == 's&c') self.$router.push('/GPTModelManagement');
    //             else
    //               self.Get(dataResponse.data);
    //           }
    //           if (dataResponse.status == 1 && dataResponse.data.is_exist) {
    //             self.$swal.fire({
    //               icon: 'error',
    //               title: 'Model ID Display publish. Is exist',
    //               showConfirmButton: false,
    //               timer: 1800,
    //             });
    //           }
    //           self.dialog = false;
    //         },
    //         (errorResource) => {
    //           self.dialog = false;
    //           self.Adddialog = false;
    //           console.error(errorResource);
    //         }
    //       );
    //     } else if (self.GPTModel.isPublish && !self.GPTModel_isPublish) {
    //       self.$call.UpdateGPTModel(
    //         self.GPTModel,
    //         (dataResponse) => {
    //           if (dataResponse.status == 0) {
    //             self.$swal.fire({
    //               icon: 'success',
    //               title: dataResponse.message,
    //               showConfirmButton: false,
    //               timer: 1500,
    //             });
    //             if (actions == 's&c') self.$router.push('/GPTModelManagement');
    //           }
    //           if (dataResponse.status == 1 && dataResponse.data.is_exist) {
    //             self.$swal.fire({
    //               icon: 'error',
    //               title: 'Model ID Display publish. Is exist',
    //               showConfirmButton: false,
    //               timer: 1800,
    //             });
    //           }
    //           self.dialog = false;
    //         },
    //         (errorResource) => {
    //           self.dialog = false;
    //           self.Adddialog = false;
    //           console.error(errorResource);
    //         }
    //       );
    //     } else if (!self.GPTModel.isPublish) {
    //       self.$call.UpdateGPTModel(
    //         self.GPTModel,
    //         (dataResponse) => {
    //           if (dataResponse.status == 0) {
    //             self.$swal.fire({
    //               icon: 'success',
    //               title: dataResponse.message,
    //               showConfirmButton: false,
    //               timer: 1500,
    //             });
    //             if (actions == 's&c') self.$router.push('/GPTModelManagement');
    //           }
    //           if (dataResponse.status == 1 && dataResponse.data.is_exist) {
    //             self.$swal.fire({
    //               icon: 'error',
    //               title: 'Model ID Display publish. Is exist',
    //               showConfirmButton: false,
    //               timer: 1800,
    //             });
    //           }
    //           self.dialog = false;
    //         },
    //         (errorResource) => {
    //           self.dialog = false;
    //           self.Adddialog = false;
    //           console.error(errorResource);
    //         }
    //       );
    //     }
    //   } catch (error) {
    //     this.LogTrace(error, 'DeleteGroup');
    //   }
    // },
    // async Edit(item) {
    //   let self = this;
    //   self.isEditAction = true;
    //   self.GPTModel_isPublish = item.isPublish;
    //   self.GPTModel.modelId = item.modelID;
    //   self.GPTModel.modelName = item.modelName;
    //   self.GPTModel.provider = item.provider;
    //   self.GPTModel.model = item.model;
    //   self.GPTModel.APIVersion = item.apiVersion;
    //   self.GPTModel.extension = item.extension;
    //   self.GPTModel.description = item.description;
    //   self.GPTModel.promptTemplate = item.promptTemplate;
    //   self.GPTModel.gender = item.gender;
    //   self.GPTModel.vectordbName = item.vectordbName;
    //   self.GPTModel.groupReplaceID = item.groupReplaceID;
    //   self.GPTModel.topVDB = item.topVDB;
    //   self.GPTModel.internet = item.internet;
    //   self.GPTModel.feedback = item.feedback;
    //   self.GPTModel.historyCount = item.historyCount;
    //   self.GPTModel.historyMinute = item.historyMinute;
    //   self.GPTModel.temperature = item.temperature;
    //   self.GPTModel.topP = item.top_p;
    //   self.GPTModel.frequencyPenalty = item.frequency_penalty;
    //   self.GPTModel.presencePenalty = item.presence_penalty;
    //   self.GPTModel.stop = item.stop;
    //   self.GPTModel.maxTokens = item.max_tokens;
    //   self.GPTModel.isStream = item.isStream;
    //   self.GPTModel.isBypass = item.isBypass;
    //   self.GPTModel.isFeedback = item.isFeedback;
    //   self.GPTModel.isAllowImage = item.isAllowImage;
    //   self.GPTModel.versioning = item.versioning;
    //   self.GPTModel.isPublish = item.isPublish;
    //   self.GPTModel.modelIDGroup = item.modelIDGroup;
    //   self.GPTModel.modelDisplay = item.modelDisplay;
    //   self.GPTModel.Len_ShortMemory = item.len_ShortMemory ?? 200;
    //   self.GPTModel.IsLongTerm_Memory = self.GPTModel.provider == 'Google' ? false : (item.isLongTerm_Memory ?? false);
    //   self.GPTModel.IsChainMassage = item.isChainMassage ?? false;
    //   self.GPTModel.LanChainMassage = item.lanChainMassage;
    //   self.GPTModel.TimeSecondChainMassage = item.timeSecondChainMassage;
    //   self.GPTModel.Cosine = item.cosine;
    //   self.GPTModel.DataIntegrationID = item.dataIntegrationID;
    //   self.GPTModel.SqlModelID = item.sqlModelID;
    //   self.GPTModel.IntentGroupID = item.intentGroupID;
    //   self.GPTModel.typingSpeed = parseInt(item.typingSpeed)
    //   self.GPTModel.maximumChatInput = parseInt(item.maximumChatInput)

    //   self.EditdialogUser = true;
    //   let templistDDVector = self.DDVector.map(item => item.name);
    //   self.GPTModel.vectordbName = self.GPTModel.vectordbName.filter(item =>templistDDVector.includes(item));
    // },
    // checkValidate() {
    //   if (this.GPTModel.vectordbName != null && this.GPTModel.vectordbName != '') {
    //     if (this.GPTModel.topVDB == '' || this.GPTModel.topVDB == null) {
    //       return "Required.";
    //     } else if (parseInt(this.GPTModel.topVDB) == 0) {
    //       return "Required.";
    //     }
    //   }
    //   return true;
    // },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }

      this.today = dd + '/' + mm + '/' + yyyy;
    },
    // isNumber: function (evt) {
    //   evt = evt || window.event;
    //   let charCode = evt.which ? evt.which : evt.keyCode;
    //   if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46 && charCode !== 45) {
    //     evt.preventDefault();
    //   } else {
    //     return true;
    //   }
    // },
    // isNumberpositive: function (evt) {
    //   evt = evt || window.event;
    //   let charCode = evt.which ? evt.which : evt.keyCode;
    //   if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    //     evt.preventDefault();
    //   } else {
    //     return true;
    //   }
    // },
    maxNumberpositive: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      
      let inputValue = evt.target.value.toString();
      let selectionStart = evt.target.selectionStart;
      let selectionEnd = evt.target.selectionEnd;
      let newValue;

      if (selectionStart !== selectionEnd) {
        // If there is a text selection, we need to replace the selected text
        newValue = inputValue.substring(0, selectionStart) + evt.key + inputValue.substring(selectionEnd);
      } else {
        // Otherwise, we are inserting the new character at the cursor position
        newValue = inputValue.substring(0, selectionStart) + evt.key + inputValue.substring(selectionStart);
      }

      if ((charCode < 48 || charCode > 57) || // Check if the key is not a number
          newValue.length > 6 || // Check if the length exceeds 6 characters
          (parseInt(newValue) > 200000)) { // Check if the number exceeds 200000
        evt.preventDefault();
      } else {
        return true;
      }
    },
    validatePrompt(inputValue) {
      if (!inputValue) {
        return true;
      }
      if (this.maxLengthChar == null) {
        return true
      } else {
        return inputValue.length <= this.maxLengthChar || 'กรุณากรอกข้อมูลตัวอักษรไม่เกิน ' + this.convertNumberToStringFormat(this.maxLengthChar);
      }
    },
    validateInput0_1(inputValue) {
      // ตรวจสอบว่าข้อมูลที่ป้อนเข้ามาเป็นตัวเลขที่อยู่ระหว่าง 0 ถึง 1 ที่มีทศนิยม 2 ตำแหน่ง
      const value = parseFloat(inputValue);
      if (isNaN(value)) return 'Required.';
      return (value >= 0 && value <= 1 && this.isTwoDecimalPlaces(value)) || 'กรุณาป้อนตัวเลขระหว่าง 0 ถึง 1 ที่มีทศนิยม 2 ตำแหน่ง';
    },
    validateInput0_2(inputValue) {
      // ตรวจสอบว่าข้อมูลที่ป้อนเข้ามาเป็นตัวเลขที่อยู่ระหว่าง 0 ถึง 2 ที่มีทศนิยม 2 ตำแหน่ง
      const value = parseFloat(inputValue);
      if (isNaN(value)) return true;
      return (value >= 0 && value <= 2 && this.isTwoDecimalPlaces(value)) || 'กรุณาป้อนตัวเลขระหว่าง 0 ถึง 2 ที่มีทศนิยม 2 ตำแหน่ง';
    },
    isTwoDecimalPlaces(number) {
      const regex = /^\d+(\.\d{1,2})?$/;
      return regex.test(number.toString());
    },
    convertNumberToStringFormat(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    customFilter(fn, listData) {
      const f = [];
      for (let i = 0; i < listData.length; i++) {
        if (fn(listData[i])) {
          f.push(listData[i]);
        }
      }
      return f;
    },
    async changeProvider(value) {
      let self = this;
      if (value == null || value == '') {
        self.DDModelShow = []; 
        return 'Required.';
      } else {
        if(value == "Google" || value == "Anthropic") {
          self.DDModelShow = self.listDDModel.filter((e) => e.provider == value );
        }
        else {
          self.DDModelShow = self.listDDModel.filter((e) => e.provider == value || e.provider == "Azure");
        }
      }
    },
    async changeModel(value) {
      let self = this;
      if (value == null || value == '') {
        self.maxLengthChar = 0;
        return 'required.';
      } else {
        let ddm = self.listDDModel.find((e) => e.modelName == value);
        if (ddm) {
          if (value == 'gpt-35-turbo') {
            self.maxLengthChar = 4000;
          } else if (value == 'gpt-35-turbo-16k') {
            self.maxLengthChar = 8000;
          } else if (value == 'gpt-4') {
            self.maxLengthChar = 6000;
          } else {
            self.maxLengthChar = null;
          }
          self.GPTModel.APIVersion = ddm.apiVersion;
          // self.maxLengthChar = self.DDModel.find((e) => e.model == value).maxPrompt;
        } else {
          self.maxLengthChar = null;
        }
      }
    },
    numericKey: function (evt) {
      evt = (evt) ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();
      if (!/^\d*\.?\d*$/.test(expect) || parseFloat(expect) <= 0) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    showPromptTemplate() {
      let self = this;
      if(self.DDGroupPromptTemplate.length > 0){
        self.showPromptTem = !self.showPromptTem;
      }else{
        self.showPromptTem = false;
      }
    },
    showAll(){
      let self = this
      self.dialogShowAll = true;
    },
    callGetDD(call){
      this.isParam = call;
    },
    fetchModelDetail(modelId) {
      return new Promise((resolve, reject) => {
        this.$call.GetGPTModelById(
          modelId,
          (dataResponse) => {
            if (dataResponse.status === 0) {
              resolve(dataResponse.data);
              return;
            }

            reject(new Error(dataResponse.message || 'Unable to load model detail'));
          },
          (errorResource) => {
            reject(errorResource);
          }
        );
      });
    },
    async openCompareVersionSelector() {
      if (!this.$route.query.id || !this.GPTModel.modelIDGroup) {
        return;
      }

      this.compareVersionDialog = true;
      this.loadingCompareVersions = true;
      const request = {
        page: 1,
        perPage: 20,
        modelId: this.$route.query.id,
        modelIDGroup: this.GPTModel.modelIDGroup,
      };

      this.$call.GetTableGPTModelVersioning(
        request,
        (dataResponse) => {
          if (dataResponse.status === 0) {
            this.compareVersions = dataResponse.data.data || [];
          } else {
            this.compareVersions = [];
          }
          this.loadingCompareVersions = false;
        },
        (errorResource) => {
          console.error(errorResource);
          this.compareVersions = [];
          this.loadingCompareVersions = false;
        }
      );
    },
    async compareWithVersion(versionItem) {
      this.compareLoading = true;
      try {
        const compareModel = await this.fetchModelDetail(versionItem.modelId);
        this.compareExcludedKeys = ['versioning', 'isPublish'];
        this.comparePayload = {
          leftModel: compareModel,
          rightModel: JSON.parse(JSON.stringify(this.GPTModel)),
          leftTitle: `v${versionItem.versioning}`,
          rightTitle: 'Current Draft',
        };
        this.compareVersionDialog = false;
        this.compareDialog = true;
      } catch (error) {
        console.error(error);
        this.$swal.fire({
          icon: 'error',
          title: 'Compare failed',
          text: 'Unable to load the selected version for comparison.',
          confirmButtonColor: '#d33',
        });
      } finally {
        this.compareLoading = false;
      }
    },
    closeCompareDialog() {
      this.compareDialog = false;
      this.comparePayload = {
        leftModel: null,
        rightModel: null,
        leftTitle: '',
        rightTitle: '',
      };
    },
    compareWithFile(filePayload) {
      if (!filePayload || !filePayload.data) {
        this.$swal.fire({
          icon: 'error',
          title: 'Invalid JSON',
          text: 'The selected file is not valid JSON.',
          confirmButtonColor: '#d33',
        });
        return;
      }
      this.compareExcludedKeys = ['versioning', 'isPublish', 'modelDisplay', 'modelId'];
      this.comparePayload = {
        leftModel: filePayload.data,
        rightModel: JSON.parse(JSON.stringify(this.GPTModel)),
        leftTitle: filePayload.name,
        rightTitle: 'Current Draft',
      };
      this.compareDialog = true;
    },
    applyComparedField(payload) {
      if (!payload || !payload.key) {
        return;
      }

      this.GPTModel[payload.key] = payload.value;

      if (this.comparePayload.rightModel) {
        this.comparePayload = {
          ...this.comparePayload,
          rightModel: {
            ...this.comparePayload.rightModel,
            [payload.key]: payload.value,
          },
        };
      }
    },
  },
  async mounted() {
    let self = this;
    self.GetDate();
    self.callGetDD("GetAllDDModelManagement");
    self.callGetDD("getModel");
    // await self.GetDDVectorName();
    // await self.GetDDLDataIntegration();
    // await self.GetlistDDGPTModelIsPublish();
    // await self.GetDDGroupReplaceDB();
    // await self.GetDDPromptTemplate();
    // await self.GetAllDDModelManagement();
    if (!self.$route.query.id) 
    {
      self.GPTModel.temperature = 0;
      self.GPTModel.topP = 0;
      self.GPTModel.gender = 'm';
      self.GPTModel.historyCount = 2;
      self.GPTModel.historyMinute = 10;
      self.GPTModel.Len_ShortMemory = 200;
      self.GPTModel.maximumChatInput = 200000;
    }
  },

}
</script>
<style scoped>
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
}

textarea {
  min-height: 800px !important;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

.icon {
  order: 0;
}

.header {
  order: 1;
  font-weight: 700;
}

.v-text-field ::v-deep label {
  font-size: 0.9375rem;
}

.v-expansion-panel-header {
  padding: 0;
}
:deep(.expan-Pannel .v-expansion-panel--active > .v-expansion-panel-header) {
  min-height: 48px;
}

.compare-dialog-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1f2937;
}

.compare-dialog-subtitle {
  font-size: 0.9rem;
  color: #6b7280;
  margin-top: 4px;
}

.compare-dialog-card {
  border-radius: 18px !important;
}
</style>
